import { StylesConfig } from "react-select";

interface OptionType {
    value: string;
    label: string;
    type?: string;
}

const selectStyles: StylesConfig<OptionType, false> = {
    control: (base) => ({
        ...base,
        borderRadius: '0.2rem',
        boxShadow: 'none',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#EEF0FA' : base.backgroundColor,
        color: state.isSelected ? '#000' : base.color,
    }),
};

export default selectStyles;